/**
 * OBS London 2012 Olympic Games — REAL Broadcast Template Registry
 * Source: London 2012 OBS Graphics Guide (actual template IDs extracted from official PDF)
 * Total: ~1,312 templates across 36 Olympic sports
 *
 * Template IDs exactly match the OBS guide (AT002, AT138, SW002, CT161, etc.)
 * 5 Sub-categories: LOWER THIRDS | SPLITS & TIMES | SCORES & MATCH | RESULTS & STANDINGS | RECORDS & BUGS
 */

// ─── SW (49 templates) ─────────────────────────────────────────
export const SW_TEMPLATES = [
  { id: "SW103", name: "Weather", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW102", name: "Venue ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW105", name: "Start List", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW104", name: "Event Schedule", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW106", name: "Athlete ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW107", name: "Position on Screen", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW131", name: "Location", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW109", name: "In-Race Place ID", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW108", name: "In-Race ID", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW111", name: "Group Members", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW110", name: "Group Indicator", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW112", name: "Gap between", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW113", name: "Gap between", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW117", name: "MF St", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "SW114", name: "Winner/Winners/Place ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "SW118", name: "St", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW119", name: "St", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW121", name: "Medal ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "SW120", name: "Ceremony ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW123", name: "Medal Presenter ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW122", name: "Medals List", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "SW124", name: "Flower Presenter ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW126", name: "Race Clock with Delta Clock", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "SW125", name: "Race Clock", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "SW128", name: "Race Clock before Split Point/Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "SW129", name: "Race Clock at Split Point with St", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "SW130", name: "Race Clock at Finish with St", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "SW003", name: "Event Schedule", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW002", name: "Venue ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW014", name: "Non-Competition Area Indicator", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW005", name: "Start List", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW004", name: "Event ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW006", name: "Lane ID", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW007", name: "Team List by Lane", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW008", name: "Records", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW009", name: "Lane Indicator", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW011", name: "Winner/Winners/Place ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "SW012", name: "Result", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "SW013", name: "Advance All to Phase", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "SW016", name: "Medal ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "SW015", name: "Ceremony ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW017", name: "Medals List", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "SW018", name: "Medal Presenter ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW019", name: "Flower Presenter ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "SW020", name: "Race Clock", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "SW021", name: "Race Clock before Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "SW022", name: "Race Clock at Split Point with St", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "SW023", name: "Race Clock before Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "SW024", name: "Race Clock at Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
];

// ─── DV (18 templates) ─────────────────────────────────────────
export const DV_TEMPLATES = [
  { id: "DV003", name: "Event Schedule", icon: "🤿", subCat: "SCORES & MATCH" },
  { id: "DV002", name: "Venue ID", icon: "🤿", subCat: "LOWER THIRDS" },
  { id: "DV004", name: "Start List", icon: "🤿", subCat: "SCORES & MATCH" },
  { id: "DV005", name: "Athlete/Pair ID", icon: "🤿", subCat: "LOWER THIRDS" },
  { id: "DV006", name: "Officials (Individual)", icon: "🤿", subCat: "LOWER THIRDS" },
  { id: "DV007", name: "Officials (Synch)", icon: "🤿", subCat: "LOWER THIRDS" },
  { id: "DV008", name: "Dive ID", icon: "🤿", subCat: "SCORES & MATCH" },
  { id: "DV009", name: "Position ID (Synch)", icon: "🤿", subCat: "SCORES & MATCH" },
  { id: "DV010", name: "Scorecard (Indivi", icon: "🤿", subCat: "SCORES & MATCH" },
  { id: "DV011", name: "Scorecard (Synch)", icon: "🤿", subCat: "SCORES & MATCH" },
  { id: "DV014", name: "Top", icon: "🤿", subCat: "SCORES & MATCH" },
  { id: "DV015", name: "Standings/Result", icon: "🤿", subCat: "SCORES & MATCH" },
  { id: "DV012", name: "Winner/Winners/Place ID", icon: "🤿", subCat: "RESULTS & STANDINGS" },
  { id: "DV017", name: "Medal ID", icon: "🤿", subCat: "RESULTS & STANDINGS" },
  { id: "DV016", name: "Ceremony ID", icon: "🤿", subCat: "LOWER THIRDS" },
  { id: "DV018", name: "Medals List", icon: "🤿", subCat: "RESULTS & STANDINGS" },
  { id: "DV019", name: "Medal Presenter ID", icon: "🤿", subCat: "LOWER THIRDS" },
  { id: "DV020", name: "Flower Presenter ID", icon: "🤿", subCat: "LOWER THIRDS" },
];

// ─── SY (19 templates) ─────────────────────────────────────────
export const SY_TEMPLATES = [
  { id: "SY003", name: "Event Schedule", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "SY002", name: "Venue ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "SY004", name: "Officials List", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "SY005", name: "Start List", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "SY006", name: "Athlete/Duet/Team ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "SY008", name: "Position ID (Duet)", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "SY007", name: "Team List", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "SY010", name: "ID with Tech Score", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "SY009", name: "Coach ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "SY012", name: "Routine Breakdown", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "SY013", name: "Routine Breakdown", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "SY014", name: "Combined Score", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "SY016", name: "Standings/Result", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "SY015", name: "Winner/s Place ID", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "SY018", name: "Medal ID", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "SY017", name: "Ceremony ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "SY019", name: "Medals List", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "SY020", name: "Medal Presenter ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "SY021", name: "Flower Presenter ID", icon: "🤸", subCat: "LOWER THIRDS" },
];

// ─── WP (33 templates) ─────────────────────────────────────────
export const WP_TEMPLATES = [
  { id: "WP003", name: "Event Schedule", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP002", name: "Venue ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP004", name: "Match ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP006", name: "St", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP005", name: "Group List", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP007", name: "Team ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP009", name: "Previous Results", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP008", name: "Team List", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP010", name: "Player ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP011", name: "Major Fouls ID", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP012", name: "Captain/Goalkeeper ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP013", name: "Coach ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP015", name: "Officials List", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP014", name: "Official ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP017", name: "Match Statistics", icon: "🤽", subCat: "RESULTS & STANDINGS" },
  { id: "WP016", name: "Player Statistics", icon: "🤽", subCat: "RESULTS & STANDINGS" },
  { id: "WP018", name: "Crunch Statistics", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP020", name: "Period Breakdown", icon: "🤽", subCat: "RESULTS & STANDINGS" },
  { id: "WP019", name: "Time Outs Crunch", icon: "🤽", subCat: "SPLITS & TIMES" },
  { id: "WP021", name: "Scoreboard/Result", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP022", name: "Shoot-Out Scoreboard", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP033", name: "Bracket to Semi-Finals", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP023", name: "Advance All to Quarter-Finals", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP024", name: "Final Rank", icon: "🤽", subCat: "RESULTS & STANDINGS" },
  { id: "WP034", name: "Bracket to Gold Medal Match", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP025", name: "Ceremony ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP027", name: "Medals List", icon: "🤽", subCat: "RESULTS & STANDINGS" },
  { id: "WP026", name: "Medal ID", icon: "🤽", subCat: "RESULTS & STANDINGS" },
  { id: "WP029", name: "Flower Presenter ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP028", name: "Medal Presenter ID", icon: "🤽", subCat: "LOWER THIRDS" },
  { id: "WP031", name: "Shot Clock", icon: "🤽", subCat: "SPLITS & TIMES" },
  { id: "WP030", name: "Crunch Scoreboard", icon: "🤽", subCat: "SCORES & MATCH" },
  { id: "WP032", name: "Crunch Penalties", icon: "🤽", subCat: "SCORES & MATCH" },
];

// ─── AR (42 templates) ─────────────────────────────────────────
export const AR_TEMPLATES = [
  { id: "AR003", name: "Weather", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR002", name: "Venue ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR004", name: "Event Schedule", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR005", name: "Athlete ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR007", name: "Arrow Speed", icon: "🎯", subCat: "SPLITS & TIMES" },
  { id: "AR008", name: "Bracket to Phase", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR009", name: "Bracket to Gold Medal Match", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR010", name: "Final Rank", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "AR012", name: "Medal ID", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "AR011", name: "Ceremony ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR013", name: "Medals List", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "AR014", name: "Medal Presenter ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR015", name: "Flower Presenter ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR037", name: "Wind Indicator", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR017", name: "Ranking Round Score", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR016a", name: "Records", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR018", name: "St", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR020a", name: "Previous Results", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR019a", name: "Match ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR038", name: "Ranking Round Score", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR022a", name: "Crunch Scoreboard", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR021a", name: "In-Match ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR023", name: "Scorecard by Set", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR022b", name: "Crunch Scoreboard (with Names)", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR024", name: "Scoreboard/Match Result", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR025", name: "Shoot-Off Scoreboard", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR026", name: "Winner ID", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "AR027", name: "Clock", icon: "🎯", subCat: "SPLITS & TIMES" },
  { id: "AR019b", name: "Match ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR016b", name: "Records", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR036", name: "Team ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR006", name: "Coach ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR028", name: "Team List", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR020b", name: "Previous Results", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR029", name: "Crunch Scoreboard", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR021b", name: "In-Match ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "AR031", name: "Scoreboard", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR030", name: "Scorecard by End", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR035", name: "Shoot-Off Scoreboard", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "AR032", name: "Match Result", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "AR033", name: "Winner ID", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "AR034", name: "Clocks", icon: "🎯", subCat: "SPLITS & TIMES" },
];

export const AT_TEMPLATES = [
  { id: "AT002", name: "Venue ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT003", name: "Weather", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT004", name: "Event Schedule", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT005", name: "Warm Up/Call Room Indicator", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT006", name: "Athlete ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT007", name: "Team ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT008", name: "Ceremony ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT009", name: "Medal ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT010", name: "Medals List", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT011", name: "Medal Presenter ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT012", name: "Flower Presenter ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT013a", name: "Event ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT013b", name: "Event ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT014", name: "Records", icon: "📋", subCat: "RECORDS & BUGS" },
  { id: "AT015a", name: "Race Clock", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT015b", name: "Race Clock", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT017", name: "Start List", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT018", name: "Lane ID", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT019", name: "Team List by Lane", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT020", name: "Winner/Winners/Place ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT022", name: "Result", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT023", name: "Currently Qualifying (by Time)", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT024", name: "Advance All to Phase/Race", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT025", name: "Race Clock before Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT026", name: "Race Clock at Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT027", name: "Race Clock before Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT028", name: "Race Clock at Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT029", name: "Race Clock before Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT030", name: "Race Clock at Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT031", name: "Race Clock before Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT032", name: "Race Clock at Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT033", name: "Start List", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT034", name: "Athlete ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT035", name: "Athlete ID with Qualifying Time", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT036", name: "False Start ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT037", name: "In-Race ID", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT038", name: "Leader ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT039", name: "Winner/Winners/Place ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT041", name: "Result", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT042", name: "Currently Qualifying (by Time)", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT043", name: "Advance All to Phase/Race", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT044", name: "Standings", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT045", name: "Race Clock at Lap Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT046", name: "Race Clock before Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT047", name: "Race Clock at Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT048", name: "Race Clock before Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT049", name: "Race Clock at Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT050", name: "Race Clock at Lap Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT051", name: "Race Clock at Lap/Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT052", name: "Race Clock at Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT053", name: "Race Clock before Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT054", name: "Race Clock at Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT055", name: "Race Clock at Lap Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT056", name: "Race Clock before Lap/Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT057", name: "Race Clock at Lap/Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT058", name: "Race Clock at Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT059", name: "Race Clock before Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT060", name: "Race Clock at Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT061", name: "Race Clock at Lap Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT062", name: "Race Clock before Lap/Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT063", name: "Race Clock at Lap/Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT064", name: "Race Clock at Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT065", name: "Race Clock before Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT066", name: "Race Clock at Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT068", name: "Start List", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT069", name: "Records", icon: "📋", subCat: "RECORDS & BUGS" },
  { id: "AT070", name: "Qualifying Performance Indicator", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT071", name: "ID Before Jump/Throw", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT072", name: "Throw History", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT073", name: "Jump History", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT074", name: "Runway Speed", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT075", name: "Indicator Foot before Board", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT076", name: "Bar Height Indicator", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT077", name: "Attempt ID (Height)", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT078", name: "Jump History", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT079", name: "Qualifying Range", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT080", name: "Multi-Field Top", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT081", name: "Standings", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT082", name: "Winner/Place ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT083", name: "Standings", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT084", name: "Countdown Clock (Pole Vault)", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT085", name: "Records", icon: "📋", subCat: "RECORDS & BUGS" },
  { id: "AT086", name: "Score After X Events", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT087", name: "Athlete Rank by Event (Decathlon)", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT088", name: "Athlete Rank by Event (Heptathlon)", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT089", name: "Result Points per Event", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT090", name: "Standings", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT091", name: "Standings", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT092", name: "Standings", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT093", name: "Overall Winner/Place ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT094", name: "Athlete ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT095", name: "Race Clock before Lap/Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT096", name: "Race Clock at Lap/Split Point", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT097", name: "Race Clock before Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT098", name: "Race Clock at Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT099", name: "Athlete ID with Score After X Events", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT102", name: "Venue ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT103", name: "Weather", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT104", name: "Event Schedule", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT105", name: "Start List", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT106", name: "Athlete ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT107", name: "Records", icon: "📋", subCat: "RECORDS & BUGS" },
  { id: "AT108", name: "Location", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT109", name: "Position on Screen", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT110", name: "In-Race ID", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT111", name: "ID with Penalty (Race Walk ONLY)", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT112", name: "In-Race Place ID", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT113", name: "Group Indicator", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT114", name: "Group Members", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT115", name: "Gap between", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT116", name: "Gap between", icon: "📋", subCat: "SCORES & MATCH" },
  { id: "AT117", name: "Penalty Standings (Race Walk ONLY)", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT118", name: "Multi-Field Standings", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT119", name: "Standings", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT120", name: "Winner/Winners/Place ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT123", name: "Standings", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT124", name: "Ceremony ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT125", name: "Medal ID", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT126", name: "Medals List", icon: "🏆", subCat: "RESULTS & STANDINGS" },
  { id: "AT127", name: "Medal Presenter ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT128", name: "Flower Presenter ID", icon: "🏃", subCat: "LOWER THIRDS" },
  { id: "AT130", name: "Race Clock", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT131", name: "Records", icon: "📋", subCat: "RECORDS & BUGS" },
  { id: "AT132", name: "Race Clock with Delta Clock", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT133", name: "Race Clock with Reaction Time", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT134", name: "Race Clock before Split Point/Finish", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT135", name: "Race Clock at Split Point with Standings", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT137", name: "Lap time (Race Walk ONLY)", icon: "⏱️", subCat: "SPLITS & TIMES" },
  { id: "AT138", name: "Race Clock at Finish with Standings", icon: "⏱️", subCat: "SPLITS & TIMES" }
];

// ─── BD (28 templates) ─────────────────────────────────────────
export const BD_TEMPLATES = [
  { id: "BD003", name: "Venue ID (Court)", icon: "🏸", subCat: "LOWER THIRDS" },
  { id: "BD002", name: "Venue ID", icon: "🏸", subCat: "LOWER THIRDS" },
  { id: "BD004", name: "Event Schedule", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD005", name: "Match ID", icon: "🏸", subCat: "LOWER THIRDS" },
  { id: "BD007", name: "St", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD006", name: "Group List", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD008", name: "Player/Doubles ID", icon: "🏸", subCat: "LOWER THIRDS" },
  { id: "BD009", name: "Previous Results", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD011", name: "Position on Court (Singles)", icon: "🏸", subCat: "LOWER THIRDS" },
  { id: "BD010", name: "Official ID", icon: "🏸", subCat: "LOWER THIRDS" },
  { id: "BD013", name: "Player Position (Doubles)", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD012", name: "Position on Court (Doubles)", icon: "🏸", subCat: "LOWER THIRDS" },
  { id: "BD014a", name: "Crunch Scoreboard (with Names)", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD015", name: "Point Indicator", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD014b", name: "Crunch Scoreboard", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD016", name: "Scoreboard/Result", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD017", name: "Match Statistics", icon: "🏸", subCat: "RESULTS & STANDINGS" },
  { id: "BD018", name: "Player/Team Service Faults", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD019", name: "Crunch Statistics", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD020", name: "Winner/s ID", icon: "🏸", subCat: "RESULTS & STANDINGS" },
  { id: "BD021", name: "Advance All to Phase", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD022", name: "Bracket to Phase", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD023", name: "Bracket to Gold Medal Match", icon: "🏸", subCat: "SCORES & MATCH" },
  { id: "BD025", name: "Medal ID", icon: "🏸", subCat: "RESULTS & STANDINGS" },
  { id: "BD024", name: "Ceremony ID", icon: "🏸", subCat: "LOWER THIRDS" },
  { id: "BD026", name: "Medals List", icon: "🏸", subCat: "RESULTS & STANDINGS" },
  { id: "BD027", name: "Medal Presenter ID", icon: "🏸", subCat: "LOWER THIRDS" },
  { id: "BD028", name: "Flower Presenter ID", icon: "🏸", subCat: "LOWER THIRDS" },
];

// ─── BK (41 templates) ─────────────────────────────────────────
export const BK_TEMPLATES = [
  { id: "BK003", name: "Event Schedule", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK002", name: "Venue ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK004", name: "Game ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK006", name: "St", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK005", name: "Group List", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK008", name: "Team List", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK007", name: "Team ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK010", name: "Reserves", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK009", name: "Starting Lineup", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK011", name: "Previous Results", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK013", name: "Officials List", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK012", name: "Official ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK019", name: "Game Player Single Statistics", icon: "🏀", subCat: "RESULTS & STANDINGS" },
  { id: "BK016", name: "Player ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK021", name: "Game Player Q", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK020", name: "Game Player Triple Statistics", icon: "🏀", subCat: "RESULTS & STANDINGS" },
  { id: "BK017", name: "Substitution ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK015", name: "Coach ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK018", name: "Substitution", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK014", name: "Player ID without Position", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK022", name: "Tournament Player Single Statistics", icon: "🏀", subCat: "RESULTS & STANDINGS" },
  { id: "BK023", name: "Tournament Player Double Statistics", icon: "🏀", subCat: "RESULTS & STANDINGS" },
  { id: "BK024", name: "Tournament Player Triple Statistics", icon: "🏀", subCat: "RESULTS & STANDINGS" },
  { id: "BK027", name: "Crunch Team Statistics", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK028", name: "Game Statistics", icon: "🏀", subCat: "RESULTS & STANDINGS" },
  { id: "BK026", name: "Leading Scorers", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK029", name: "Scoreboard/Result", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK030", name: "Points Breakdown by Quarter", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK031", name: "Points Breakdown by Half", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK033", name: "Bracket to Semi-Finals", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK032", name: "Advance All to Quarter-Finals", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK035", name: "Final Rank", icon: "🏀", subCat: "RESULTS & STANDINGS" },
  { id: "BK034", name: "Bracket to Gold Medal Game", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK036", name: "Ceremony ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK038", name: "Medals List", icon: "🏀", subCat: "RESULTS & STANDINGS" },
  { id: "BK037", name: "Medal ID", icon: "🏀", subCat: "RESULTS & STANDINGS" },
  { id: "BK040", name: "Flower Presenter ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK039", name: "Medal Presenter ID", icon: "🏀", subCat: "LOWER THIRDS" },
  { id: "BK042", name: "Crunch Scoreboard (Last Minute)", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK041", name: "Crunch Scoreboard", icon: "🏀", subCat: "SCORES & MATCH" },
  { id: "BK043", name: "Shot Clock", icon: "🏀", subCat: "SPLITS & TIMES" },
];

// ─── BV (35 templates) ─────────────────────────────────────────
export const BV_TEMPLATES = [
  { id: "BV003", name: "Weather", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV002", name: "Venue ID", icon: "🏖️", subCat: "LOWER THIRDS" },
  { id: "BV004", name: "Event Schedule", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV005", name: "Match ID", icon: "🏖️", subCat: "LOWER THIRDS" },
  { id: "BV007", name: "Standings", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV006", name: "Pool List", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV008", name: "Team ID", icon: "🏖️", subCat: "LOWER THIRDS" },
  { id: "BV010", name: "Previous Results", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV009", name: "Team List", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV012", name: "Official ID", icon: "🏖️", subCat: "LOWER THIRDS" },
  { id: "BV011", name: "Player ID", icon: "🏖️", subCat: "LOWER THIRDS" },
  { id: "BV014", name: "Position on Court", icon: "🏖️", subCat: "LOWER THIRDS" },
  { id: "BV013", name: "Officials List", icon: "🏖️", subCat: "LOWER THIRDS" },
  { id: "BV016a", name: "Crunch Scoreboard (with Names)", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV015", name: "Player Position", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV017", name: "Serve Speed", icon: "🏖️", subCat: "SPLITS & TIMES" },
  { id: "BV016b", name: "Crunch Scoreboard", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV018", name: "Point Indicator", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV019", name: "Player Statistics", icon: "🏖️", subCat: "RESULTS & STANDINGS" },
  { id: "BV021", name: "Player Triple Statistics", icon: "🏖️", subCat: "RESULTS & STANDINGS" },
  { id: "BV020", name: "Player Service Statistics", icon: "🏖️", subCat: "RESULTS & STANDINGS" },
  { id: "BV022", name: "Crunch Statistics", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV023", name: "Scoreboard/Result", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV024", name: "Winner ID", icon: "🏖️", subCat: "RESULTS & STANDINGS" },
  { id: "BV026", name: "Match Statistics", icon: "🏖️", subCat: "RESULTS & STANDINGS" },
  { id: "BV025", name: "Set Statistics", icon: "🏖️", subCat: "RESULTS & STANDINGS" },
  { id: "BV027", name: "Advance All to Phase", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV029", name: "Bracket to Gold Medal Match", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV028", name: "Bracket to Phase", icon: "🏖️", subCat: "SCORES & MATCH" },
  { id: "BV031", name: "Ceremony ID", icon: "🏖️", subCat: "LOWER THIRDS" },
  { id: "BV030", name: "Final Rank", icon: "🏖️", subCat: "RESULTS & STANDINGS" },
  { id: "BV033", name: "Medals List", icon: "🏖️", subCat: "RESULTS & STANDINGS" },
  { id: "BV032", name: "Medal ID", icon: "🏖️", subCat: "RESULTS & STANDINGS" },
  { id: "BV035", name: "Flower Presenter ID", icon: "🏖️", subCat: "LOWER THIRDS" },
  { id: "BV034", name: "Medal Presenter ID", icon: "🏖️", subCat: "LOWER THIRDS" },
];

// ─── BX (19 templates) ─────────────────────────────────────────
export const BX_TEMPLATES = [
  { id: "BX003", name: "Event Schedule", icon: "🥊", subCat: "SCORES & MATCH" },
  { id: "BX002", name: "Venue ID", icon: "🥊", subCat: "LOWER THIRDS" },
  { id: "BX005", name: "ID with Corner", icon: "🥊", subCat: "SCORES & MATCH" },
  { id: "BX004", name: "Bout ID", icon: "🥊", subCat: "LOWER THIRDS" },
  { id: "BX007", name: "Referee ID", icon: "🥊", subCat: "LOWER THIRDS" },
  { id: "BX006", name: "Previous Results", icon: "🥊", subCat: "SCORES & MATCH" },
  { id: "BX009", name: "Position in Ring", icon: "🥊", subCat: "LOWER THIRDS" },
  { id: "BX008", name: "Judges List", icon: "🥊", subCat: "LOWER THIRDS" },
  { id: "BX010", name: "Scoreboard/Result", icon: "🥊", subCat: "SCORES & MATCH" },
  { id: "BX011", name: "Winner ID", icon: "🥊", subCat: "RESULTS & STANDINGS" },
  { id: "BX013", name: "Bracket to Gold Medal Bout", icon: "🥊", subCat: "SCORES & MATCH" },
  { id: "BX012", name: "Bracket to Phase", icon: "🥊", subCat: "SCORES & MATCH" },
  { id: "BX015", name: "Ceremony ID", icon: "🥊", subCat: "LOWER THIRDS" },
  { id: "BX014", name: "Final Rank", icon: "🥊", subCat: "RESULTS & STANDINGS" },
  { id: "BX017", name: "Medals List", icon: "🥊", subCat: "RESULTS & STANDINGS" },
  { id: "BX016", name: "Medal ID", icon: "🥊", subCat: "RESULTS & STANDINGS" },
  { id: "BX019", name: "Flower Presenter ID", icon: "🥊", subCat: "LOWER THIRDS" },
  { id: "BX018", name: "Medal Presenter ID", icon: "🥊", subCat: "LOWER THIRDS" },
  { id: "BX020", name: "Crunch Clock", icon: "🥊", subCat: "SPLITS & TIMES" },
];

// ─── CS (30 templates) ─────────────────────────────────────────
export const CS_TEMPLATES = [
  { id: "CS003", name: "Weather", icon: "🛶", subCat: "SCORES & MATCH" },
  { id: "CS002", name: "Venue ID", icon: "🛶", subCat: "LOWER THIRDS" },
  { id: "CS005", name: "Course Description", icon: "🛶", subCat: "SCORES & MATCH" },
  { id: "CS004", name: "Event Schedule", icon: "🛶", subCat: "SCORES & MATCH" },
  { id: "CS007", name: "Athlete/Doubles ID", icon: "🛶", subCat: "LOWER THIRDS" },
  { id: "CS006", name: "Event ID", icon: "🛶", subCat: "LOWER THIRDS" },
  { id: "CS018", name: "Top", icon: "🛶", subCat: "SCORES & MATCH" },
  { id: "CS008", name: "Gate Statistics", icon: "🛶", subCat: "SCORES & MATCH" },
  { id: "CS009", name: "Ceremony ID", icon: "🛶", subCat: "LOWER THIRDS" },
  { id: "CS010", name: "Medal ID", icon: "🛶", subCat: "RESULTS & STANDINGS" },
  { id: "CS011", name: "Medals List", icon: "🛶", subCat: "RESULTS & STANDINGS" },
  { id: "CS013", name: "Flower Presenter ID", icon: "🛶", subCat: "LOWER THIRDS" },
  { id: "CS012", name: "Medal Presenter ID", icon: "🛶", subCat: "LOWER THIRDS" },
  { id: "CS014", name: "Start List", icon: "🛶", subCat: "SCORES & MATCH" },
  { id: "CS015", name: "Athlete/Doubles ID with Run", icon: "🛶", subCat: "LOWER THIRDS" },
  { id: "CS016", name: "Athlete/Doubles Result", icon: "🛶", subCat: "RESULTS & STANDINGS" },
  { id: "CS017", name: "Athlete/Doubles Run Breakdown", icon: "🛶", subCat: "RESULTS & STANDINGS" },
  { id: "CS019", name: "St", icon: "🛶", subCat: "SCORES & MATCH" },
  { id: "CS020", name: "Start List", icon: "🛶", subCat: "SCORES & MATCH" },
  { id: "CS021", name: "Athlete/Doubles Result", icon: "🛶", subCat: "RESULTS & STANDINGS" },
  { id: "CS023", name: "St", icon: "🛶", subCat: "SCORES & MATCH" },
  { id: "CS024", name: "Winner/Winners/Place ID", icon: "🛶", subCat: "RESULTS & STANDINGS" },
  { id: "CS025", name: "Race Clock", icon: "🛶", subCat: "SPLITS & TIMES" },
  { id: "CS026", name: "Race Clock with Penalties", icon: "🛶", subCat: "SPLITS & TIMES" },
  { id: "CS028", name: "Race Clock at Split Point", icon: "🛶", subCat: "SPLITS & TIMES" },
  { id: "CS027", name: "Race Clock before Split Point", icon: "🛶", subCat: "SPLITS & TIMES" },
  { id: "CS029", name: "Race Clock before Finish (Heats Run", icon: "🛶", subCat: "SPLITS & TIMES" },
  { id: "CS030", name: "Race Clock at Finish (Heats Run", icon: "🛶", subCat: "SPLITS & TIMES" },
  { id: "CS031", name: "Race Clock before Finish (Heats Run", icon: "🛶", subCat: "SPLITS & TIMES" },
  { id: "CS032", name: "Race Clock at Finish (Heats Run", icon: "🛶", subCat: "SPLITS & TIMES" },
];

// ─── CF (25 templates) ─────────────────────────────────────────
export const CF_TEMPLATES = [
  { id: "CF003", name: "Weather", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF002", name: "Venue ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "CF004", name: "Event Schedule", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF006", name: "Start List", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF005", name: "Event ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "CF007", name: "Lane ID", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF009", name: "Athlete ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "CF008", name: "Team List by Lane", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF028", name: "Records", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF010", name: "Lane Indicator", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF011", name: "Leader ID", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF012", name: "MF St", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "CF013", name: "St", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF014", name: "Winner/Winners/Place ID", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "CF016", name: "Result", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "CF017", name: "Advance All to Phase/Race", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "CF018", name: "Ceremony ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "CF019", name: "Medal ID", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "CF020", name: "Medals List", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "CF022", name: "Flower Presenter ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "CF021", name: "Medal Presenter ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "CF025", name: "Race Clock before Split Point/Finish", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "CF024", name: "Race Clock", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "CF026", name: "Race Clock at Split Point with Standings", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "CF027", name: "Race Clock at Finish", icon: "🚣", subCat: "SPLITS & TIMES" },
];

// ─── CT (158 templates) ─────────────────────────────────────────
export const CT_TEMPLATES = [
  { id: "CT003", name: "Event Schedule", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT002", name: "Venue ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT005", name: "Medal ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT004", name: "Ceremony ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT006", name: "Medals List", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT007", name: "Medal Presenter ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT008", name: "Flower Presenter ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT108", name: "Start Countdown Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT010", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT011", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT012", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT014", name: "Winner/Winners/Place ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT013", name: "In-Race ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT017", name: "Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT018", name: "Advance", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT019", name: "Advance All to Phase", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT020", name: "Laps to Go", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT022", name: "Race Clock at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT021", name: "Race Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT024", name: "Athlete Points after X Races", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT023", name: "Athlete ID with Previous Points", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT025", name: "Athlete Rank by Race", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT026", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT027", name: "Rank by Race Analysis", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT028", name: "Winner/Place ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT030", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT029", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT031", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT032", name: "In-Race ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT034", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT033", name: "Athlete Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT035", name: "Clock at/after", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT161", name: "Clock at Split", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT036", name: "Clock at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT037", name: "Race Description", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT039", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT038", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT040", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT042", name: "Lapped the Field ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT041", name: "In-Race ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT043", name: "Sprint Winner/Place ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT045", name: "Leader/Place ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT044", name: "MF Sprint X Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT046", name: "Top", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT047", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT050", name: "Clock with Sprint Number", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT049", name: "Race Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT051", name: "Clock with Laps to Go", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT053", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT052", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT054", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT056", name: "Eliminated ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT055", name: "In-Race ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT057", name: "Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT059", name: "Clock with Sprint Number", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT058", name: "Race Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT062", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT063", name: "Heat ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT168", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT064", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT060", name: "Records", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT065", name: "Athlete Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT061", name: "Split Screen", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT066", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT067", name: "Clocks before Split Point/Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT068", name: "Clocks at Split Point", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT069", name: "Clocks at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT071", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT070", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT072", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT074", name: "Leader/Place ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT073", name: "In-Race ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT075", name: "Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT076", name: "Race Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT077", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT079", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT080", name: "Heat ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT081", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT082", name: "Split Screen", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT078", name: "Records", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT083", name: "Athlete Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT084", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT162", name: "Clocks before Split Point/Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT163", name: "Clocks at Split Point", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT164", name: "Clocks at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT086", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT085", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT088", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT087", name: "Records", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT090", name: "In-Race ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT091", name: "Athlete Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT092", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT093", name: "Clock at/after", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT165", name: "Clock at", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT094", name: "Clock at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT095", name: "Start List (races with", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT096", name: "Start List (races with", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT170", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT097", name: "Heat ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT098", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT100", name: "Position on Track (", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT099", name: "In-Race ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT101", name: "Position on Track (", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT103", name: "Winner ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT104", name: "Heat/Race Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT105", name: "Result (Best of", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT106", name: "Advance All to Phase/Race", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT107", name: "Final Rank", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT109", name: "Clock at/after", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT110", name: "Clock at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT112", name: "Team ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT111", name: "Records", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT113", name: "Team List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT115", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT114", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT118", name: "Team Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT117", name: "In-Race Team ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT172", name: "MF St", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT119", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT121", name: "Race Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT123", name: "Clock at Split Point", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT124", name: "Clock at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT125", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT171", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT126", name: "Heat ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT129", name: "Overl", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT128", name: "Split Screen", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT130", name: "Winner ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT131", name: "Race Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT133", name: "Final Rank", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT132", name: "Advance All to Race", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT136", name: "Clocks before Split Point/Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT137", name: "Clocks at Split Point", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT138", name: "Clocks at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT167", name: "Records", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT139", name: "Team ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT140", name: "Team List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT143", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT144", name: "Heat ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT175", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT145", name: "Time to Qualify", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT146", name: "Team Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT173", name: "MF St", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT147", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT148", name: "Race Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT149", name: "Race Clock at Split/Lap Point", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT150", name: "Race Clock at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT151", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT176", name: "Event ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CT152", name: "Heat ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT154", name: "Winner ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT155", name: "Race Result", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT174", name: "MF St", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT157", name: "Final Rank", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CT156", name: "Advance All to Race", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CT158", name: "Race Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT159", name: "Race Clock at Split/Lap Point", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CT160", name: "Race Clock at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
];

// ─── CR (40 templates) ─────────────────────────────────────────
export const CR_TEMPLATES = [
  { id: "CR003", name: "Weather", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR002", name: "Venue ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CR005", name: "Location", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR004", name: "Event Schedule", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR006", name: "Ceremony ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CR007", name: "Medal ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CR008", name: "Medals List", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CR010", name: "Flower Presenter ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CR009", name: "Medal Presenter ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CR011", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR013", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CR012", name: "Team List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR014", name: "Position on Screen", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CR016", name: "In-Race Place ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR015", name: "In-Race ID", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR017", name: "Group Indicator", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR033", name: "Lap Indicator", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR018", name: "Group Members", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR019", name: "Gap between", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR020", name: "Gap between", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR021", name: "MF St", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CR022", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR023", name: "Winner/Winners/Place ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CR025", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR028", name: "Race Clock with Delta Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CR027", name: "Race Clock", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CR029", name: "Distance to Ride", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CR031", name: "Race Clock at Split Point", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CR030", name: "Race Clock before Split Point/Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CR032", name: "Race Clock at Finish", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CR040", name: "Start List", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR041", name: "Athlete ID", icon: "🚴", subCat: "LOWER THIRDS" },
  { id: "CR042", name: "Athlete Time", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CR043", name: "MF St", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CR046", name: "St", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR044", name: "Winner/Winners/Place ID", icon: "🚴", subCat: "RESULTS & STANDINGS" },
  { id: "CR048", name: "Individual Race Clock with Athlete Name", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CR047", name: "Athlete Name", icon: "🚴", subCat: "SCORES & MATCH" },
  { id: "CR049", name: "Individual Race Clock before Split Point", icon: "🚴", subCat: "SPLITS & TIMES" },
  { id: "CR050", name: "Individual Race Clock at Split Point", icon: "🚴", subCat: "SPLITS & TIMES" },
];

// ─── CM (25 templates) ─────────────────────────────────────────
export const CM_TEMPLATES = [
  { id: "CM203", name: "Weather", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM202", name: "Venue ID", icon: "🚵", subCat: "LOWER THIRDS" },
  { id: "CM205", name: "Start List", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM204", name: "Event Schedule", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM206", name: "Athlete ID", icon: "🚵", subCat: "LOWER THIRDS" },
  { id: "CM207", name: "In-Race ID", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM208", name: "In-Race Place ID", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM209", name: "Group Indicator", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM210", name: "Group Members", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM211", name: "Gap between", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM212", name: "Gap between", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM213", name: "MF St", icon: "🚵", subCat: "RESULTS & STANDINGS" },
  { id: "CM214", name: "St", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM215", name: "Winner/Winners/Place ID", icon: "🚵", subCat: "RESULTS & STANDINGS" },
  { id: "CM217", name: "St", icon: "🚵", subCat: "SCORES & MATCH" },
  { id: "CM219", name: "Medal ID", icon: "🚵", subCat: "RESULTS & STANDINGS" },
  { id: "CM218", name: "Ceremony ID", icon: "🚵", subCat: "LOWER THIRDS" },
  { id: "CM221", name: "Medal Presenter ID", icon: "🚵", subCat: "LOWER THIRDS" },
  { id: "CM220", name: "Medals List", icon: "🚵", subCat: "RESULTS & STANDINGS" },
  { id: "CM222", name: "Flower Presenter ID", icon: "🚵", subCat: "LOWER THIRDS" },
  { id: "CM225", name: "Race Clock with Delta Clock", icon: "🚵", subCat: "SPLITS & TIMES" },
  { id: "CM224", name: "Race Clock", icon: "🚵", subCat: "SPLITS & TIMES" },
  { id: "CM227", name: "Race Clock at Split Point/Finish with St", icon: "🚵", subCat: "SPLITS & TIMES" },
  { id: "CM226", name: "Race Clock before Split Point", icon: "🚵", subCat: "SPLITS & TIMES" },
  { id: "CM228", name: "Race Clock with Laps to Go Indicator, Lap Time", icon: "🚵", subCat: "SPLITS & TIMES" },
];

// ─── CB (37 templates) ─────────────────────────────────────────
export const CB_TEMPLATES = [
  { id: "CB503", name: "Weather", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB502", name: "Venue ID", icon: "🚲", subCat: "LOWER THIRDS" },
  { id: "CB505", name: "Event ID", icon: "🚲", subCat: "LOWER THIRDS" },
  { id: "CB504", name: "Event Schedule", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB506", name: "Athlete ID", icon: "🚲", subCat: "LOWER THIRDS" },
  { id: "CB507", name: "Ceremony ID", icon: "🚲", subCat: "LOWER THIRDS" },
  { id: "CB509", name: "Medals List", icon: "🚲", subCat: "RESULTS & STANDINGS" },
  { id: "CB508", name: "Medal ID", icon: "🚲", subCat: "RESULTS & STANDINGS" },
  { id: "CB511", name: "Flower Presenter ID", icon: "🚲", subCat: "LOWER THIRDS" },
  { id: "CB510", name: "Medal Presenter ID", icon: "🚲", subCat: "LOWER THIRDS" },
  { id: "CB512a", name: "Start List", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB513", name: "Athlete Result", icon: "🚲", subCat: "RESULTS & STANDINGS" },
  { id: "CB514", name: "Top", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB515", name: "St", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB517", name: "Race Clock before Split Point", icon: "🚲", subCat: "SPLITS & TIMES" },
  { id: "CB516", name: "Race Clock", icon: "🚲", subCat: "SPLITS & TIMES" },
  { id: "CB519", name: "Race Clock before Finish", icon: "🚲", subCat: "SPLITS & TIMES" },
  { id: "CB518", name: "Race Clock at Split Point", icon: "🚲", subCat: "SPLITS & TIMES" },
  { id: "CB520", name: "Race Clock at Finish", icon: "🚲", subCat: "SPLITS & TIMES" },
  { id: "CB512b", name: "Start List", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB536a", name: "Athlete ID with Total Points", icon: "🚲", subCat: "LOWER THIRDS" },
  { id: "CB523a", name: "Athlete Total Score", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB524", name: "St", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB527a", name: "Advance All to Semi-Finals", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB512c", name: "Start List", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB523b", name: "Athlete Total Score", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB536b", name: "Athlete ID with Total Points", icon: "🚲", subCat: "LOWER THIRDS" },
  { id: "CB526", name: "St", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB527b", name: "Advance All to Final", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB525b", name: "Winner/Winners/Place ID", icon: "🚲", subCat: "RESULTS & STANDINGS" },
  { id: "CB512d", name: "Start List", icon: "🚲", subCat: "SCORES & MATCH" },
  { id: "CB529", name: "Result", icon: "🚲", subCat: "RESULTS & STANDINGS" },
  { id: "CB532", name: "Race Clock before Split Point", icon: "🚲", subCat: "SPLITS & TIMES" },
  { id: "CB531", name: "Race Clock", icon: "🚲", subCat: "SPLITS & TIMES" },
  { id: "CB534", name: "Race Clock before Finish", icon: "🚲", subCat: "SPLITS & TIMES" },
  { id: "CB533", name: "Race Clock at Split Point with Leader", icon: "🚲", subCat: "SPLITS & TIMES" },
  { id: "CB535", name: "Race Clock at Finish with St", icon: "🚲", subCat: "SPLITS & TIMES" },
];

// ─── EQ (52 templates) ─────────────────────────────────────────
export const EQ_TEMPLATES = [
  { id: "EQ003", name: "Weather", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ002", name: "Venue ID", icon: "🏇", subCat: "LOWER THIRDS" },
  { id: "EQ004", name: "Event Schedule", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ005", name: "Event ID", icon: "🏇", subCat: "LOWER THIRDS" },
  { id: "EQ006", name: "Rider & Team ID", icon: "🏇", subCat: "LOWER THIRDS" },
  { id: "EQ008", name: "ID with Horse", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ007", name: "Chef d", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ009", name: "MF Standings (Individual)", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ010", name: "MF Standings (Team)", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ011", name: "Winner/Place ID (Indivi", icon: "🏇", subCat: "RESULTS & STANDINGS" },
  { id: "EQ012", name: "Winner/Place ID (Team)", icon: "🏇", subCat: "RESULTS & STANDINGS" },
  { id: "EQ013", name: "Ceremony ID", icon: "🏇", subCat: "LOWER THIRDS" },
  { id: "EQ015", name: "Medal ID (Team)", icon: "🏇", subCat: "RESULTS & STANDINGS" },
  { id: "EQ014", name: "Medal ID (Indivi", icon: "🏇", subCat: "RESULTS & STANDINGS" },
  { id: "EQ016", name: "Medals List (Indivi", icon: "🏇", subCat: "RESULTS & STANDINGS" },
  { id: "EQ019", name: "Flower Presenter ID", icon: "🏇", subCat: "LOWER THIRDS" },
  { id: "EQ018", name: "Medal Presenter ID", icon: "🏇", subCat: "LOWER THIRDS" },
  { id: "EQ020", name: "Start List", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ058", name: "ID with Rider Breakdown", icon: "🏇", subCat: "RESULTS & STANDINGS" },
  { id: "EQ021", name: "In-Ride ID with Horse", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ022", name: "Movement/Obstacle Indicator", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ023", name: "Effort Statistics (Cross Country)", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ026", name: "Rider Breakdown", icon: "🏇", subCat: "RESULTS & STANDINGS" },
  { id: "EQ027", name: "Team Scorecard", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ029", name: "St", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ030", name: "St", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ031", name: "Clock", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ032", name: "Clock with Penalties", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ033", name: "Time Allowed", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ034", name: "Clock", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ035", name: "Clock with Penalties", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ036", name: "Time Allowed", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ037", name: "Start List", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ039", name: "Rider Score (GP & GPS)", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ038", name: "Movement Indicator", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ040", name: "Rider Score (GPF)", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ041", name: "Team Scorecard", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ042", name: "St", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ043", name: "St", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ044", name: "Start List", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ047", name: "Rider Score", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ045", name: "ID with Previous Total", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ048", name: "Team Scorecard", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ049", name: "St", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ050", name: "St", icon: "🏇", subCat: "SCORES & MATCH" },
  { id: "EQ051", name: "Clock", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ052", name: "Clock with Penalties", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ053", name: "Time Allowed", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ054", name: "Clock (Jump Off)", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ055", name: "Clock with Penalties (Jump Off)", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ057", name: "Clock at Finish (Jump Off)", icon: "🏇", subCat: "SPLITS & TIMES" },
  { id: "EQ056", name: "Clock before Finish (Jump Off)", icon: "🏇", subCat: "SPLITS & TIMES" },
];

// ─── FE (35 templates) ─────────────────────────────────────────
export const FE_TEMPLATES = [
  { id: "FE003", name: "Venue ID (Piste)", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE002", name: "Venue ID", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE005", name: "Athlete/Team ID", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE004", name: "Event Schedule", icon: "🤺", subCat: "SCORES & MATCH" },
  { id: "FE006", name: "Referee ID", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE008", name: "Scoring Lights", icon: "🤺", subCat: "SCORES & MATCH" },
  { id: "FE007", name: "Split Screen", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE009", name: "Winner ID", icon: "🤺", subCat: "RESULTS & STANDINGS" },
  { id: "FE010", name: "Bracket to Semi-Finals", icon: "🤺", subCat: "SCORES & MATCH" },
  { id: "FE011", name: "Bracket to Gold Medal Match", icon: "🤺", subCat: "SCORES & MATCH" },
  { id: "FE012", name: "Final Rank", icon: "🤺", subCat: "RESULTS & STANDINGS" },
  { id: "FE013", name: "Ceremony ID", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE014", name: "Medal ID", icon: "🤺", subCat: "RESULTS & STANDINGS" },
  { id: "FE015", name: "Medals List", icon: "🤺", subCat: "RESULTS & STANDINGS" },
  { id: "FE017", name: "Flower Presenter ID", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE016", name: "Medal Presenter ID", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE032", name: "Clock with Lights", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE033", name: "Clock with Lights", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE019a", name: "Previous Results", icon: "🤺", subCat: "SCORES & MATCH" },
  { id: "FE018a", name: "Bout ID", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE020", name: "Scoreboard/Result", icon: "🤺", subCat: "SCORES & MATCH" },
  { id: "FE022", name: "Clock with Lights", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE021", name: "Clock", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE024", name: "Clock with Lights", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE023", name: "Clock", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE025", name: "Team List", icon: "🤺", subCat: "SCORES & MATCH" },
  { id: "FE018b", name: "Team Match ID", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE019b", name: "Previous Results", icon: "🤺", subCat: "SCORES & MATCH" },
  { id: "FE026", name: "Bout Result", icon: "🤺", subCat: "RESULTS & STANDINGS" },
  { id: "FE018c", name: "Bout ID", icon: "🤺", subCat: "LOWER THIRDS" },
  { id: "FE027", name: "Team Match Scoreboard/Result", icon: "🤺", subCat: "SCORES & MATCH" },
  { id: "FE029", name: "Clock with Lights", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE028", name: "Clock", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE031", name: "Clock with Lights", icon: "🤺", subCat: "SPLITS & TIMES" },
  { id: "FE030", name: "Clock", icon: "🤺", subCat: "SPLITS & TIMES" },
];

// ─── FB (36 templates) ─────────────────────────────────────────
export const FB_TEMPLATES = [
  { id: "FB003", name: "Weather", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB002", name: "Venue ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB004", name: "Event Schedule", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB005", name: "Match ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB006", name: "Group List", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB007", name: "St", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB008", name: "Team ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB009", name: "Starting Lineup", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB010", name: "Substitutes List", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB011", name: "Previous Results", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB013", name: "Officials List", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB012", name: "Official ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB014", name: "Player ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB017", name: "Crunch Scoreboard", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB020", name: "Match Player Statistics", icon: "⚽", subCat: "RESULTS & STANDINGS" },
  { id: "FB021", name: "Tournament Player Statistics", icon: "⚽", subCat: "RESULTS & STANDINGS" },
  { id: "FB019", name: "Substitution ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB018", name: "Substitution List", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB015", name: "Captain/Goalkeeper ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB016", name: "Coach ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB023", name: "Match Statistics", icon: "⚽", subCat: "RESULTS & STANDINGS" },
  { id: "FB022", name: "Crunch Statistics", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB024", name: "Scoreboard/Result/Result with PSO Score", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB025", name: "Goal Summary", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB027", name: "Penalty Sh", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB028", name: "Penalty Sh", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB030", name: "Bracket to Semi-Finals", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB029", name: "Advance All to Quarter-Finals", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB032", name: "Final Rank", icon: "⚽", subCat: "RESULTS & STANDINGS" },
  { id: "FB031", name: "Bracket to Gold Medal Match", icon: "⚽", subCat: "SCORES & MATCH" },
  { id: "FB026", name: "Additional Time Indicator", icon: "⚽", subCat: "SPLITS & TIMES" },
  { id: "FB034", name: "Medal ID", icon: "⚽", subCat: "RESULTS & STANDINGS" },
  { id: "FB033", name: "Ceremony ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB036", name: "Medal Presenter ID", icon: "⚽", subCat: "LOWER THIRDS" },
  { id: "FB035", name: "Medals List", icon: "⚽", subCat: "RESULTS & STANDINGS" },
  { id: "FB037", name: "Flower Presenter ID", icon: "⚽", subCat: "LOWER THIRDS" },
];

// ─── GA (43 templates) ─────────────────────────────────────────
export const GA_TEMPLATES = [
  { id: "GA003", name: "Event Schedule", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA002", name: "Venue ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GA004", name: "Event Schedule (A", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA005", name: "Event ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GA006", name: "Athlete/Team ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GA007", name: "Officials List", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GA009", name: "Ceremony ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GA010", name: "Medal ID", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "GA011", name: "Medals List", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "GA013", name: "Flower Presenter ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GA012", name: "Medal Presenter ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GA015", name: "Team/Mixed Group List", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA016a", name: "Scorecard", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA028", name: "Scorecard", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA017a", name: "Athlete/Team Total", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA018a", name: "Athlete/Team Build (Women)", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA019a", name: "Athlete/Team Build (Men)", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA020a", name: "St", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA021a", name: "St", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA022a", name: "Vault St", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "GA030", name: "Team List", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA014b", name: "Start List", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA017b", name: "Team Total", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA016b", name: "Scorecard", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA018b", name: "Team Build (Women)", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA019b", name: "Team Build (Men)", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA027b", name: "Top", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA026a", name: "Winner/Place ID", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "GA020b", name: "St", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA029", name: "Scorecard", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA025a", name: "Start List", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA017c", name: "Athlete Total", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA018c", name: "Athlete Build (Women)", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA019c", name: "Athlete Build (Men)", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA027a", name: "Top", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA026b", name: "Winner/Place ID", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "GA020c", name: "St", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA025b", name: "Start List", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA016c", name: "Scorecard", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA027c", name: "Top", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA026c", name: "Winner/Place ID", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "GA021b", name: "St", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GA022b", name: "Vault St", icon: "🤸", subCat: "RESULTS & STANDINGS" },
];

// ─── GR (20 templates) ─────────────────────────────────────────
export const GR_TEMPLATES = [
  { id: "GR103", name: "Event Schedule", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR102", name: "Venue ID", icon: "🎀", subCat: "LOWER THIRDS" },
  { id: "GR106", name: "Start List", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR104", name: "Event ID", icon: "🎀", subCat: "LOWER THIRDS" },
  { id: "GR107", name: "Start List", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR105", name: "Officials List", icon: "🎀", subCat: "LOWER THIRDS" },
  { id: "GR108", name: "Athlete/Group ID", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR110", name: "Scorecard", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR109", name: "Group List", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR112", name: "Athlete/Group Build", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR113", name: "Top", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR116", name: "St", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR114", name: "St", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR115", name: "St", icon: "🎀", subCat: "SCORES & MATCH" },
  { id: "GR117", name: "Winner/Place ID", icon: "🎀", subCat: "RESULTS & STANDINGS" },
  { id: "GR118", name: "Ceremony ID", icon: "🎀", subCat: "LOWER THIRDS" },
  { id: "GR119", name: "Medal ID", icon: "🎀", subCat: "RESULTS & STANDINGS" },
  { id: "GR120", name: "Medals List", icon: "🎀", subCat: "RESULTS & STANDINGS" },
  { id: "GR122", name: "Flower Presenter ID", icon: "🎀", subCat: "LOWER THIRDS" },
  { id: "GR121", name: "Medal Presenter ID", icon: "🎀", subCat: "LOWER THIRDS" },
];

// ─── GT (18 templates) ─────────────────────────────────────────
export const GT_TEMPLATES = [
  { id: "GT203", name: "Event Schedule", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GT202", name: "Venue ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GT204", name: "Event ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GT205", name: "Start List", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GT207", name: "Judges List", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GT206", name: "Official ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GT208", name: "Athlete ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GT210", name: "Scorecard", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GT209", name: "Athlete ID with Routine", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GT211", name: "Top", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GT212", name: "Standings Breakdown (Qualification)", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GT213", name: "Standings/Result", icon: "🤸", subCat: "SCORES & MATCH" },
  { id: "GT214", name: "Winner/Place ID", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "GT215", name: "Victory Ceremony ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GT217", name: "Medals List", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "GT216", name: "Medal ID", icon: "🤸", subCat: "RESULTS & STANDINGS" },
  { id: "GT219", name: "Flower Presenter ID", icon: "🤸", subCat: "LOWER THIRDS" },
  { id: "GT218", name: "Medal Presenter ID", icon: "🤸", subCat: "LOWER THIRDS" },
];

// ─── HB (31 templates) ─────────────────────────────────────────
export const HB_TEMPLATES = [
  { id: "HB003", name: "Event Schedule", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB002", name: "Venue ID", icon: "🤾", subCat: "LOWER THIRDS" },
  { id: "HB004", name: "Match ID", icon: "🤾", subCat: "LOWER THIRDS" },
  { id: "HB006", name: "St", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB005", name: "Group List", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB007", name: "Team ID", icon: "🤾", subCat: "LOWER THIRDS" },
  { id: "HB009", name: "Previous Results", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB008", name: "Team List", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB010", name: "Player ID", icon: "🤾", subCat: "LOWER THIRDS" },
  { id: "HB012", name: "Referee ID", icon: "🤾", subCat: "LOWER THIRDS" },
  { id: "HB011", name: "Coach ID", icon: "🤾", subCat: "LOWER THIRDS" },
  { id: "HB014", name: "Player Statistics", icon: "🤾", subCat: "RESULTS & STANDINGS" },
  { id: "HB013", name: "Referees List", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB015", name: "Crunch Statistics", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB017", name: "Match Statistics", icon: "🤾", subCat: "RESULTS & STANDINGS" },
  { id: "HB016", name: "Leading Scorers", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB018", name: "Scoreboard/Result", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB019", name: "Points Breakdown by Half", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB020", name: "Shoot-Out Scoreboard", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB021", name: "Shoot-Out Crunch", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB023", name: "Bracket to Semi-Finals", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB022", name: "Advance All to Quarter-Finals", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB025", name: "Final Rank", icon: "🤾", subCat: "RESULTS & STANDINGS" },
  { id: "HB024", name: "Bracket to Gold Medal Match", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB026", name: "Ceremony ID", icon: "🤾", subCat: "LOWER THIRDS" },
  { id: "HB028", name: "Medals List", icon: "🤾", subCat: "RESULTS & STANDINGS" },
  { id: "HB027", name: "Medal ID", icon: "🤾", subCat: "RESULTS & STANDINGS" },
  { id: "HB030", name: "Flower Presenter ID", icon: "🤾", subCat: "LOWER THIRDS" },
  { id: "HB029", name: "Medal Presenter ID", icon: "🤾", subCat: "LOWER THIRDS" },
  { id: "HB032", name: "Crunch Penalties", icon: "🤾", subCat: "SCORES & MATCH" },
  { id: "HB031", name: "Crunch Scoreboard", icon: "🤾", subCat: "SCORES & MATCH" },
];

// ─── HO (34 templates) ─────────────────────────────────────────
export const HO_TEMPLATES = [
  { id: "HO004", name: "Weather", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO002", name: "Venue ID", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO005", name: "Event Schedule", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO006", name: "Match ID", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO008", name: "Standings", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO007", name: "Pool List", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO009", name: "Team ID", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO011", name: "Substitutes List", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO010", name: "Starting Lineup", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO012", name: "Previous Results", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO013", name: "Player ID", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO014", name: "Captain/Goalkeeper ID", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO015", name: "Coach ID", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO017", name: "Umpires List", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO016", name: "Umpire ID", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO037", name: "Team Video Referral ID/Result", icon: "🏑", subCat: "RESULTS & STANDINGS" },
  { id: "HO038", name: "Video Umpire Referral ID/Result", icon: "🏑", subCat: "RESULTS & STANDINGS" },
  { id: "HO020", name: "Match Player Statistics", icon: "🏑", subCat: "RESULTS & STANDINGS" },
  { id: "HO021", name: "Tournament Player Statistics", icon: "🏑", subCat: "RESULTS & STANDINGS" },
  { id: "HO022", name: "Crunch Statistics", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO024", name: "Scoreboard/Result/Result with Shoot-Out Score", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO023", name: "Match Statistics", icon: "🏑", subCat: "RESULTS & STANDINGS" },
  { id: "HO026", name: "Shoot-Out Scoreboard", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO025", name: "Goal Summary", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO029", name: "Bracket to Gold Medal Match", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO028", name: "Advance All to Semi-Finals", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO031", name: "Ceremony ID", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO030", name: "Final Rank", icon: "🏑", subCat: "RESULTS & STANDINGS" },
  { id: "HO033", name: "Medals List", icon: "🏑", subCat: "RESULTS & STANDINGS" },
  { id: "HO032", name: "Medal ID", icon: "🏑", subCat: "RESULTS & STANDINGS" },
  { id: "HO035", name: "Flower Presenter ID", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO034", name: "Medal Presenter ID", icon: "🏑", subCat: "LOWER THIRDS" },
  { id: "HO027", name: "Shoot-Out Crunch", icon: "🏑", subCat: "SCORES & MATCH" },
  { id: "HO036", name: "Crunch Scoreboard", icon: "🏑", subCat: "SCORES & MATCH" },
];

// ─── JU (22 templates) ─────────────────────────────────────────
export const JU_TEMPLATES = [
  { id: "JU003", name: "Venue ID (Mat)", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "JU002", name: "Venue ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "JU005", name: "Contest ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "JU004", name: "Event Schedule", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "JU006", name: "ID with Colour", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "JU007", name: "Previous Results", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "JU009", name: "Position on Mat", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "JU008", name: "Official ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "JU010", name: "Scoreboard/Result", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "JU011", name: "Winner ID", icon: "🥋", subCat: "RESULTS & STANDINGS" },
  { id: "JU013", name: "Bracket to Semi-Finals", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "JU012", name: "Advance", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "JU015", name: "Final Rank", icon: "🥋", subCat: "RESULTS & STANDINGS" },
  { id: "JU014", name: "Bracket to Gold Medal Contest", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "JU017", name: "Medal ID", icon: "🥋", subCat: "RESULTS & STANDINGS" },
  { id: "JU016", name: "Ceremony ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "JU019", name: "Medal Presenter ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "JU018", name: "Medals List", icon: "🥋", subCat: "RESULTS & STANDINGS" },
  { id: "JU020", name: "Flower Presenter ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "JU021", name: "Crunch Scoreboard", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "JU023", name: "Immobilisation Clock", icon: "🥋", subCat: "SPLITS & TIMES" },
  { id: "JU022", name: "Crunch Scoreboard with Golden Score", icon: "🥋", subCat: "SCORES & MATCH" },
];

// ─── MP (54 templates) ─────────────────────────────────────────
export const MP_TEMPLATES = [
  { id: "MP003", name: "Weather", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP002", name: "Venue ID", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP005", name: "Event ID", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP004", name: "Event Schedule", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP034", name: "Athlete ID (ALL COMPETITORS)", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP006", name: "St", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP014", name: "Start List", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP013", name: "Fencing Points Description", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP015", name: "Bout ID", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP016", name: "Athlete ID", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP018", name: "Athlete Result", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP017", name: "Position on Screen", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP019", name: "St", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP021", name: "Clock with Lights", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP020", name: "Clock", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP023", name: "Start List (by Heat)", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP022", name: "Swimming Points Description", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP024", name: "Lane ID (by Heat)", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP025", name: "Athlete Result (by Heat)", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP026", name: "Result (by Heat)", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP027", name: "St", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP029", name: "Race Clock at Finish with Winner", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP028", name: "Race Clock", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP031", name: "Riding Points Description", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP030", name: "Horse Draw Area Indicator", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP032", name: "Start List", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP035", name: "Athlete Result", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP033", name: "ID with Horse", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP036", name: "St", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP038", name: "Clock", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP037", name: "Start Clock", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP039", name: "Clock with Penalties", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP040", name: "Time Allowed", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP042", name: "Start List", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP041", name: "Combined Event Points Description", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP043", name: "Athlete ID", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP045", name: "In-Race Place ID", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP044", name: "In-Race ID", icon: "🏅", subCat: "SCORES & MATCH" },
  { id: "MP050", name: "In-Race Shooting Time ID", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP051", name: "Athlete Result", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP052", name: "Winner/Place ID", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP053", name: "Result", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP008", name: "Ceremony ID", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP054", name: "Race Analysis", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP010", name: "Medals List", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP009", name: "Medal ID", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP012", name: "Flower Presenter ID", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP011", name: "Medal Presenter ID", icon: "🏅", subCat: "LOWER THIRDS" },
  { id: "MP056", name: "Race Clock with Start Times", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP057", name: "Race Clock", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP060", name: "Race Clock at Split Point", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP059", name: "Race Clock before Split Point/Finish", icon: "🏅", subCat: "SPLITS & TIMES" },
  { id: "MP061", name: "Shooting Stack", icon: "🏅", subCat: "RESULTS & STANDINGS" },
  { id: "MP062", name: "Race Clock at Finish", icon: "🏅", subCat: "SPLITS & TIMES" },
];

// ─── RO (40 templates) ─────────────────────────────────────────
export const RO_TEMPLATES = [
  { id: "RO003", name: "Weather", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO002", name: "Venue ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "RO005", name: "Event ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "RO004", name: "Event Schedule", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO007", name: "Start List", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO008", name: "Lane ID", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO010", name: "Team List by Lane (Eight)", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO009", name: "Team List by Lane (Four)", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO011", name: "Athlete ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "RO006", name: "Records", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO012", name: "Lane Indicator", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO013", name: "In-Race Leader/Place ID", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO014", name: "Top", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO015", name: "St", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO016", name: "Winner/Winners/Place ID", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "RO018", name: "Result", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "RO019", name: "Advance All to Phase/Race", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO020", name: "Ceremony ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "RO021", name: "Medal ID", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "RO022", name: "Medals List", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "RO024", name: "Flower Presenter ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "RO023", name: "Medal Presenter ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "RO026", name: "Start Lights", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO028", name: "Race Clock before Split Point/Finish", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO027", name: "Race Clock", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO029", name: "Race Clock at Split Point with St", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO031", name: "Boat Speed", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO030", name: "Race Clock at Finish", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO032", name: "Stroke Rate", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO033", name: "Start List", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO034", name: "Athlete/Doubles/Team ID", icon: "🚣", subCat: "LOWER THIRDS" },
  { id: "RO036", name: "Team List (Eight)", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO035", name: "Team List (Four)", icon: "🚣", subCat: "SCORES & MATCH" },
  { id: "RO037", name: "Athlete/Doubles/Team Result", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "RO038", name: "Result", icon: "🚣", subCat: "RESULTS & STANDINGS" },
  { id: "RO040", name: "Race Clock before Split Point", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO039", name: "Race Clock", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO041", name: "Race Clock at Split Point", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO043", name: "Race Clock at Finish", icon: "🚣", subCat: "SPLITS & TIMES" },
  { id: "RO042", name: "Race Clock before Finish", icon: "🚣", subCat: "SPLITS & TIMES" },
];

// ─── SA (67 templates) ─────────────────────────────────────────
export const SA_TEMPLATES = [
  { id: "SA003", name: "Weather", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA002", name: "Venue ID", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA005", name: "Event Schedule", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA006", name: "Event ID", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA007", name: "Status ID", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA008", name: "Start/Finish ID", icon: "⛵", subCat: "SPLITS & TIMES" },
  { id: "SA009", name: "Start/Finish Indicator", icon: "⛵", subCat: "SPLITS & TIMES" },
  { id: "SA010", name: "Position on Screen", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA011", name: "Mark Indicator", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA012", name: "Leg Indicator", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA014", name: "Course Indicator", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA013", name: "Course Indicator", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA015", name: "Wind Direction Indicator", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA004", name: "Wind Conditions", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA017", name: "Start v Mark Wind Speed Indicator", icon: "⛵", subCat: "SPLITS & TIMES" },
  { id: "SA016", name: "Wind/Course Direction Indicator", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA019", name: "Ceremony ID", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA018", name: "Mark Wind Speed Indicator", icon: "⛵", subCat: "SPLITS & TIMES" },
  { id: "SA020", name: "Medal ID", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA021", name: "Medals List", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA023", name: "Flower Presenter ID", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA022", name: "Medal Presenter ID", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA024", name: "Race Point Details", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA025", name: "Start List", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA026", name: "Athlete/Team ID", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA027", name: "Team List", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA028", name: "ID with Previous Points", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA029", name: "In-Race Place ID", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA033", name: "Leaders", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA030", name: "Top", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA031", name: "MF St", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA032", name: "St", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA034", name: "Race Winner/Winners/Place ID", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA036", name: "Athlete/Team Result", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA037", name: "Race Result", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA038", name: "Event Standings/Result", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA039", name: "Event Winner/Place ID", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA041", name: "Team ID", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA042", name: "Team List", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA071", name: "In-Race ID", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA045", name: "Places at Mark", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA070", name: "In-Race Leader ID", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA046", name: "Crunch Places at Mark", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA047", name: "Group List", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA049", name: "Start List (by Flight)", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA048", name: "Group Standings", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA051", name: "Match Winner ID", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA050", name: "Match ID", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA052", name: "Match Result", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA043", name: "Previous Result (Ro", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA053", name: "Start List (by Flight)", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA044", name: "Previous Result (Knockout)", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA054", name: "Match ID", icon: "⛵", subCat: "LOWER THIRDS" },
  { id: "SA056", name: "Match Winner ID", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA055", name: "ID with Previous Points", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA058", name: "Series Scoreboard/Result", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA057", name: "Series Breakdown", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA059", name: "Series Winner ID", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA060", name: "Bracket to Semi-Finals", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA062", name: "Final Rank", icon: "⛵", subCat: "RESULTS & STANDINGS" },
  { id: "SA061", name: "Bracket to Final", icon: "⛵", subCat: "SCORES & MATCH" },
  { id: "SA064", name: "Delta Clock at Mark/Finish", icon: "⛵", subCat: "SPLITS & TIMES" },
  { id: "SA063", name: "Start Countdown Clock", icon: "⛵", subCat: "SPLITS & TIMES" },
  { id: "SA065", name: "Distance to Mark", icon: "⛵", subCat: "SPLITS & TIMES" },
  { id: "SA066", name: "Current Boat Speed", icon: "⛵", subCat: "SPLITS & TIMES" },
  { id: "SA067", name: "Average Boat Speed per Leg", icon: "⛵", subCat: "SPLITS & TIMES" },
  { id: "SA069", name: "Distance between Boats", icon: "⛵", subCat: "SPLITS & TIMES" },
];

// ─── SH (46 templates) ─────────────────────────────────────────
export const SH_TEMPLATES = [
  { id: "SH003", name: "Weather (Shotgun ONLY)", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH002", name: "Venue ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "SH005", name: "Event ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "SH004", name: "Event Schedule (Finals ONLY)", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH006", name: "Gun Details", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH007", name: "Competition Details", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH008", name: "Sighting Series/Sighting Time/Test Firing Indicator", icon: "🎯", subCat: "SPLITS & TIMES" },
  { id: "SH009", name: "Records", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH011", name: "Officials List", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "SH010", name: "Official ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "SH013", name: "Athlete ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "SH014", name: "Winner/Place ID", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "SH044", name: "Winner/Place ID (Men", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "SH016", name: "Medal ID", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "SH015", name: "Ceremony ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "SH018", name: "Medal Presenter ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "SH017", name: "Medals List", icon: "🎯", subCat: "RESULTS & STANDINGS" },
  { id: "SH019", name: "Flower Presenter ID", icon: "🎯", subCat: "LOWER THIRDS" },
  { id: "SH020", name: "Start List", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH012", name: "Qualification Score", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH021a", name: "Shoot-Off Scoreboard", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH022", name: "Standings", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH023", name: "Start List", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH043a", name: "Qualification Score", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH024", name: "Scorecard", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH025", name: "Scorecard (Women", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH041", name: "Scorecard (Men", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH026", name: "Top", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH042", name: "MF Standings (Men", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH030", name: "St", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH028", name: "St", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH029", name: "Athlete Score Breakdown", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH021b", name: "Shoot-Off Scoreboard", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH027", name: "St", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH031", name: "Target/s", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH032", name: "Clock", icon: "🎯", subCat: "SPLITS & TIMES" },
  { id: "SH033", name: "Start List", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH040", name: "No Bird Indicator", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH043b", name: "Qualification Score", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH034", name: "Current Shooter (Trap)", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH036", name: "Top", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH035", name: "Scorecard (Skeet)", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH039", name: "St", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH038", name: "Athlete Score Breakdown", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH021c", name: "Shoot-Off Scoreboard", icon: "🎯", subCat: "SCORES & MATCH" },
  { id: "SH037", name: "St", icon: "🎯", subCat: "SCORES & MATCH" },
];

// ─── TT (45 templates) ─────────────────────────────────────────
export const TT_TEMPLATES = [
  { id: "TT003", name: "Venue ID (Table)", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT002", name: "Venue ID", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT005", name: "Player/Doubles/Team ID", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT004", name: "Event Schedule", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT007", name: "Official ID", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT006", name: "Officials List", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT009", name: "Expedite Indicator", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT008", name: "Time Out Indicator", icon: "🏓", subCat: "SPLITS & TIMES" },
  { id: "TT011", name: "Bracket to Gold Medal Match", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT010", name: "Bracket to Phase", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT013", name: "Medal ID", icon: "🏓", subCat: "RESULTS & STANDINGS" },
  { id: "TT012", name: "Ceremony ID", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT014", name: "Medals List", icon: "🏓", subCat: "RESULTS & STANDINGS" },
  { id: "TT015", name: "Medal Presenter ID", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT016", name: "Flower Presenter ID", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT018a", name: "Previous Results", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT017a", name: "Match ID", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT019a", name: "Position on Court", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT020a", name: "Position on Court", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT022a", name: "Crunch Scoreboard", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT021a", name: "Crunch Scoreboard (with Names)", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT023a", name: "Point Indicator", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT025a", name: "Crunch Match Statistics", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT024a", name: "Game Statistics", icon: "🏓", subCat: "RESULTS & STANDINGS" },
  { id: "TT026a", name: "Scoreboard/Result", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT027a", name: "Winner ID", icon: "🏓", subCat: "RESULTS & STANDINGS" },
  { id: "TT028a", name: "Match Statistics", icon: "🏓", subCat: "RESULTS & STANDINGS" },
  { id: "TT018b", name: "Previous Results", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT017b", name: "Team Match ID", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT029", name: "Team Match List", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT017c", name: "Match ID", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT019b", name: "Position on Court", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT030", name: "Player Position (Doubles)", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT020b", name: "Position on Court", icon: "🏓", subCat: "LOWER THIRDS" },
  { id: "TT021b", name: "Crunch Scoreboard (with Names)", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT023b", name: "Point Indicator", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT022b", name: "Crunch Scoreboard", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT025b", name: "Crunch Match Statistics", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT024b", name: "Game Statistics", icon: "🏓", subCat: "RESULTS & STANDINGS" },
  { id: "TT026b", name: "Scoreboard/Result", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT028b", name: "Match Statistics", icon: "🏓", subCat: "RESULTS & STANDINGS" },
  { id: "TT031", name: "Team Match Scoreboard/Result", icon: "🏓", subCat: "SCORES & MATCH" },
  { id: "TT032", name: "Team Match Winner ID", icon: "🏓", subCat: "RESULTS & STANDINGS" },
  { id: "TT034", name: "Final Rank", icon: "🏓", subCat: "RESULTS & STANDINGS" },
  { id: "TT033", name: "Team Match Statistics", icon: "🏓", subCat: "RESULTS & STANDINGS" },
];

// ─── TK (20 templates) ─────────────────────────────────────────
export const TK_TEMPLATES = [
  { id: "TK003", name: "Event Schedule", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "TK002", name: "Venue ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "TK005", name: "ID with Colour", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "TK004", name: "Contest ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "TK006", name: "Previous Results", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "TK007", name: "Official ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "TK009", name: "I", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "TK008", name: "Position on Screen", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "TK010", name: "Scoreboard/Result", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "TK011", name: "Winner ID", icon: "🥋", subCat: "RESULTS & STANDINGS" },
  { id: "TK012", name: "Advance", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "TK014", name: "Bracket to Gold Medal Contest", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "TK013", name: "Bracket to Semi-Finals", icon: "🥋", subCat: "SCORES & MATCH" },
  { id: "TK015", name: "Final Rank", icon: "🥋", subCat: "RESULTS & STANDINGS" },
  { id: "TK017", name: "Medal ID", icon: "🥋", subCat: "RESULTS & STANDINGS" },
  { id: "TK016", name: "Ceremony ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "TK019", name: "Medal Presenter ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "TK018", name: "Medals List", icon: "🥋", subCat: "RESULTS & STANDINGS" },
  { id: "TK020", name: "Flower Presenter ID", icon: "🥋", subCat: "LOWER THIRDS" },
  { id: "TK021", name: "Crunch Scoreboard", icon: "🥋", subCat: "SCORES & MATCH" },
];

// ─── TE (30 templates) ─────────────────────────────────────────
export const TE_TEMPLATES = [
  { id: "TE003", name: "Venue ID (Court)", icon: "🎾", subCat: "LOWER THIRDS" },
  { id: "TE002", name: "Venue ID", icon: "🎾", subCat: "LOWER THIRDS" },
  { id: "TE004", name: "Weather", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE006", name: "Match ID", icon: "🎾", subCat: "LOWER THIRDS" },
  { id: "TE005", name: "Event Schedule", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE007", name: "Player/Doubles ID", icon: "🎾", subCat: "LOWER THIRDS" },
  { id: "TE008", name: "Previous Results", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE010", name: "Position on Court (Singles)", icon: "🎾", subCat: "LOWER THIRDS" },
  { id: "TE009", name: "Chair Umpire ID", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE011", name: "Position on Court (Doubles)", icon: "🎾", subCat: "LOWER THIRDS" },
  { id: "TE013a", name: "Crunch Scoreboard (with Names)", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE012", name: "Player Position (Doubles)", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE013b", name: "Crunch Scoreboard", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE014", name: "Serve Speed", icon: "🎾", subCat: "SPLITS & TIMES" },
  { id: "TE015", name: "New Balls Indicator", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE017", name: "Point Indicator", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE016", name: "Crunch Statistics", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE018", name: "Scoreboard/Result", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE019", name: "Tie-break Scoreboard", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE020", name: "Set Statistics", icon: "🎾", subCat: "RESULTS & STANDINGS" },
  { id: "TE021", name: "Match Statistics", icon: "🎾", subCat: "RESULTS & STANDINGS" },
  { id: "TE022", name: "Winner/s ID", icon: "🎾", subCat: "RESULTS & STANDINGS" },
  { id: "TE023", name: "Bracket to Phase", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE024", name: "Bracket to Gold Medal Match", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE025", name: "Challenges Remaining", icon: "🎾", subCat: "SCORES & MATCH" },
  { id: "TE027", name: "Medal ID", icon: "🎾", subCat: "RESULTS & STANDINGS" },
  { id: "TE026", name: "Ceremony ID", icon: "🎾", subCat: "LOWER THIRDS" },
  { id: "TE028", name: "Medals List", icon: "🎾", subCat: "RESULTS & STANDINGS" },
  { id: "TE029", name: "Medal Presenter ID", icon: "🎾", subCat: "LOWER THIRDS" },
  { id: "TE030", name: "Flower Presenter ID", icon: "🎾", subCat: "LOWER THIRDS" },
];

// ─── TR (32 templates) ─────────────────────────────────────────
export const TR_TEMPLATES = [
  { id: "TR003", name: "Weather", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR002", name: "Venue ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "TR005", name: "Start List", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR004", name: "Event Schedule", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR006", name: "Athlete ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "TR039", name: "Location", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR008", name: "In-Race ID", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR007", name: "Position on Screen", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "TR009", name: "In-Race ID with Rank after Section", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR010", name: "In-Race Place ID", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR011", name: "In-Race Place ID with Rank after Section", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR012", name: "Group Indicator", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR013", name: "Group Members", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR014", name: "Gap between", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR015", name: "Gap between", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR038", name: "Stop & Go Penalty Box Indicator", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR016", name: "MF Lap St", icon: "🏊", subCat: "RESULTS & STANDINGS" },
  { id: "TR017", name: "MF Section St", icon: "🏊", subCat: "RESULTS & STANDINGS" },
  { id: "TR018", name: "Section St", icon: "🏊", subCat: "RESULTS & STANDINGS" },
  { id: "TR019", name: "Section St", icon: "🏊", subCat: "RESULTS & STANDINGS" },
  { id: "TR020", name: "Winner/Winners/Place ID", icon: "🏊", subCat: "RESULTS & STANDINGS" },
  { id: "TR023", name: "St", icon: "🏊", subCat: "SCORES & MATCH" },
  { id: "TR026", name: "Ceremony ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "TR025", name: "Athlete Rank Analysis", icon: "🏊", subCat: "RESULTS & STANDINGS" },
  { id: "TR028", name: "Medals List", icon: "🏊", subCat: "RESULTS & STANDINGS" },
  { id: "TR027", name: "Medal ID", icon: "🏊", subCat: "RESULTS & STANDINGS" },
  { id: "TR030", name: "Flower Presenter ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "TR029", name: "Medal Presenter ID", icon: "🏊", subCat: "LOWER THIRDS" },
  { id: "TR033", name: "Race Clock with Delta Clock", icon: "🏊", subCat: "SPLITS & TIMES" },
  { id: "TR032", name: "Race Clock", icon: "🏊", subCat: "SPLITS & TIMES" },
  { id: "TR036", name: "Race Clock at Split Point/Finish with St", icon: "🏊", subCat: "SPLITS & TIMES" },
  { id: "TR035", name: "Race Clock before Split Point", icon: "🏊", subCat: "SPLITS & TIMES" },
];

// ─── VO (38 templates) ─────────────────────────────────────────
export const VO_TEMPLATES = [
  { id: "VO003", name: "Event Schedule", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO002", name: "Venue ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO004", name: "Match ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO005", name: "Pool List", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO006", name: "St", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO007", name: "Team ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO009", name: "Starting Lineup", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO008", name: "Team List", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO010", name: "Previous Results", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO011", name: "Player ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO012", name: "Captain/Libero ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO013", name: "Coach ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO015", name: "Officials List", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO014", name: "Official ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO017", name: "Crunch Scoreboard", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO016", name: "Position on Court", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO018", name: "Serve Speed", icon: "🏐", subCat: "SPLITS & TIMES" },
  { id: "VO019", name: "Point Indicator", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO021", name: "Substitution ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO020", name: "Substitution", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO033", name: "Timeout Indicator", icon: "🏐", subCat: "SPLITS & TIMES" },
  { id: "VO034", name: "Technical Timeout Indicator", icon: "🏐", subCat: "SPLITS & TIMES" },
  { id: "VO022", name: "Player Statistics", icon: "🏐", subCat: "RESULTS & STANDINGS" },
  { id: "VO024", name: "Crunch Statistics", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO023", name: "Player Triple Statistics", icon: "🏐", subCat: "RESULTS & STANDINGS" },
  { id: "VO026", name: "Set Statistics", icon: "🏐", subCat: "RESULTS & STANDINGS" },
  { id: "VO025", name: "Timeout Statistics Crunch", icon: "🏐", subCat: "SPLITS & TIMES" },
  { id: "VO028", name: "Scoreboard/Result", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO027", name: "Match Statistics", icon: "🏐", subCat: "RESULTS & STANDINGS" },
  { id: "VO030", name: "Bracket to Semi-Finals", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO029", name: "Advance All to Quarter-Finals", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO032", name: "Final Rank", icon: "🏐", subCat: "RESULTS & STANDINGS" },
  { id: "VO031", name: "Bracket to Gold Medal Match", icon: "🏐", subCat: "SCORES & MATCH" },
  { id: "VO035", name: "Ceremony ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO037", name: "Medals List", icon: "🏐", subCat: "RESULTS & STANDINGS" },
  { id: "VO036", name: "Medal ID", icon: "🏐", subCat: "RESULTS & STANDINGS" },
  { id: "VO039", name: "Flower Presenter ID", icon: "🏐", subCat: "LOWER THIRDS" },
  { id: "VO038", name: "Medal Presenter ID", icon: "🏐", subCat: "LOWER THIRDS" },
];

// ─── WL (29 templates) ─────────────────────────────────────────
export const WL_TEMPLATES = [
  { id: "WL003", name: "Event Schedule", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL002", name: "Venue ID", icon: "🏋️", subCat: "LOWER THIRDS" },
  { id: "WL005", name: "Athlete ID", icon: "🏋️", subCat: "LOWER THIRDS" },
  { id: "WL004", name: "Event ID", icon: "🏋️", subCat: "LOWER THIRDS" },
  { id: "WL006", name: "Referees List", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL008", name: "Records (Lift)", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL007", name: "Jury List", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL009", name: "Records (Total)", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL010", name: "Start List", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL012a", name: "Snatch Attempt ID", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL011", name: "Warm Up Area Indicator", icon: "🏋️", subCat: "LOWER THIRDS" },
  { id: "WL012b", name: "C&J Attempt ID", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL013a", name: "Snatch Result ID", icon: "🏋️", subCat: "RESULTS & STANDINGS" },
  { id: "WL013b", name: "C&J Result ID", icon: "🏋️", subCat: "RESULTS & STANDINGS" },
  { id: "WL014", name: "St", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL017", name: "Athlete Result Breakdown", icon: "🏋️", subCat: "RESULTS & STANDINGS" },
  { id: "WL016", name: "Top", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL015", name: "Snatch Standings", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL018", name: "St", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL019", name: "St", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL021", name: "Result Total", icon: "🏋️", subCat: "RESULTS & STANDINGS" },
  { id: "WL020", name: "Winner/Place ID", icon: "🏋️", subCat: "RESULTS & STANDINGS" },
  { id: "WL023", name: "Medal ID", icon: "🏋️", subCat: "RESULTS & STANDINGS" },
  { id: "WL022", name: "Ceremony ID", icon: "🏋️", subCat: "LOWER THIRDS" },
  { id: "WL025", name: "Medal Presenter ID", icon: "🏋️", subCat: "LOWER THIRDS" },
  { id: "WL024", name: "Medals List", icon: "🏋️", subCat: "RESULTS & STANDINGS" },
  { id: "WL026", name: "Flower Presenter ID", icon: "🏋️", subCat: "LOWER THIRDS" },
  { id: "WL028", name: "Lights", icon: "🏋️", subCat: "SCORES & MATCH" },
  { id: "WL027", name: "Countdown Clock", icon: "🏋️", subCat: "SPLITS & TIMES" },
];

// ─── WR (21 templates) ─────────────────────────────────────────
export const WR_TEMPLATES = [
  { id: "WR003", name: "Venue ID (Mat)", icon: "🤼", subCat: "LOWER THIRDS" },
  { id: "WR002", name: "Venue ID", icon: "🤼", subCat: "LOWER THIRDS" },
  { id: "WR005", name: "Bout ID", icon: "🤼", subCat: "LOWER THIRDS" },
  { id: "WR004", name: "Event Schedule", icon: "🤼", subCat: "SCORES & MATCH" },
  { id: "WR006", name: "ID with Corner", icon: "🤼", subCat: "SCORES & MATCH" },
  { id: "WR007", name: "Previous Results", icon: "🤼", subCat: "SCORES & MATCH" },
  { id: "WR009", name: "Position on Mat", icon: "🤼", subCat: "LOWER THIRDS" },
  { id: "WR008", name: "Official ID", icon: "🤼", subCat: "LOWER THIRDS" },
  { id: "WR022", name: "Challenge ID", icon: "🤼", subCat: "SCORES & MATCH" },
  { id: "WR010", name: "Scoreboard/Result", icon: "🤼", subCat: "SCORES & MATCH" },
  { id: "WR011", name: "Winner ID", icon: "🤼", subCat: "RESULTS & STANDINGS" },
  { id: "WR013", name: "Bracket to Phase", icon: "🤼", subCat: "SCORES & MATCH" },
  { id: "WR012", name: "Advance", icon: "🤼", subCat: "SCORES & MATCH" },
  { id: "WR015", name: "Final Rank", icon: "🤼", subCat: "RESULTS & STANDINGS" },
  { id: "WR014", name: "Bracket to Gold Medal Bout", icon: "🤼", subCat: "SCORES & MATCH" },
  { id: "WR017", name: "Medal ID", icon: "🤼", subCat: "RESULTS & STANDINGS" },
  { id: "WR016", name: "Ceremony ID", icon: "🤼", subCat: "LOWER THIRDS" },
  { id: "WR019", name: "Medal Presenter ID", icon: "🤼", subCat: "LOWER THIRDS" },
  { id: "WR018", name: "Medals List", icon: "🤼", subCat: "RESULTS & STANDINGS" },
  { id: "WR020", name: "Flower Presenter ID", icon: "🤼", subCat: "LOWER THIRDS" },
  { id: "WR021", name: "Crunch Scoreboard", icon: "🤼", subCat: "SCORES & MATCH" },
];

// ─── MASTER LOOKUP MAP ──────────────────────────────────────────────────────
export const SPORT_TEMPLATE_MAP = {
  SW: SW_TEMPLATES,
  DV: DV_TEMPLATES,
  SY: SY_TEMPLATES,
  WP: WP_TEMPLATES,
  AR: AR_TEMPLATES,
  BD: BD_TEMPLATES,
  BK: BK_TEMPLATES,
  BV: BV_TEMPLATES,
  BX: BX_TEMPLATES,
  CS: CS_TEMPLATES,
  CF: CF_TEMPLATES,
  CT: CT_TEMPLATES,
  CR: CR_TEMPLATES,
  CM: CM_TEMPLATES,
  CB: CB_TEMPLATES,
  EQ: EQ_TEMPLATES,
  FE: FE_TEMPLATES,
  FB: FB_TEMPLATES,
  GA: GA_TEMPLATES,
  GR: GR_TEMPLATES,
  GT: GT_TEMPLATES,
  HB: HB_TEMPLATES,
  HO: HO_TEMPLATES,
  JU: JU_TEMPLATES,
  MP: MP_TEMPLATES,
  RO: RO_TEMPLATES,
  SA: SA_TEMPLATES,
  SH: SH_TEMPLATES,
  TT: TT_TEMPLATES,
  TK: TK_TEMPLATES,
  TE: TE_TEMPLATES,
  TR: TR_TEMPLATES,
  VO: VO_TEMPLATES,
  WL: WL_TEMPLATES,
  WR: WR_TEMPLATES,
};

/**
 * Get OBS London 2012 real broadcast templates for any Olympic sport.
 * Returns the exact template IDs as listed in the official OBS Graphics Guide.
 */
export function getSportTemplates(sport) {
  if (!sport) return [];

  if (sport.templates && sport.templates.length > 0) {
    return sport.templates;
  }

  const code = sport.code || "";
  if (SPORT_TEMPLATE_MAP[code]) {
    return SPORT_TEMPLATE_MAP[code];
  }

  // Name-based fallback
  const name = sport.name || "";
  if (name.includes("Swimming")) return SW_TEMPLATES;
  if (name.includes("Diving")) return DV_TEMPLATES;
  if (name.includes("Synchronised") || name.includes("Synchronized")) return SY_TEMPLATES;
  if (name.includes("Water Polo")) return WP_TEMPLATES;
  if (name.includes("Athletics") || name.includes("Track & Field")) return AT_TEMPLATES;
  if (name.includes("Marathon") || name.includes("Race Walk")) return AT_TEMPLATES;
  if (name.includes("Archery")) return AR_TEMPLATES;
  if (name.includes("Badminton")) return BD_TEMPLATES;
  if (name.includes("Basketball")) return BK_TEMPLATES;
  if (name.includes("Beach Volleyball")) return BV_TEMPLATES;
  if (name.includes("Boxing")) return BX_TEMPLATES;
  if (name.includes("Canoe Slalom")) return CS_TEMPLATES;
  if (name.includes("Canoe Sprint") || name.includes("Flatwater")) return CF_TEMPLATES;
  if (name.includes("Cycling Track")) return CT_TEMPLATES;
  if (name.includes("Cycling Road")) return CR_TEMPLATES;
  if (name.includes("Mountain Bike")) return CM_TEMPLATES;
  if (name.includes("BMX")) return CB_TEMPLATES;
  if (name.includes("Equestrian")) return EQ_TEMPLATES;
  if (name.includes("Fencing")) return FE_TEMPLATES;
  if (name.includes("Football")) return FB_TEMPLATES;
  if (name.includes("Artistic Gymnastics")) return GA_TEMPLATES;
  if (name.includes("Rhythmic")) return GR_TEMPLATES;
  if (name.includes("Trampoline")) return GT_TEMPLATES;
  if (name.includes("Handball")) return HB_TEMPLATES;
  if (name.includes("Hockey") || name.includes("Field Hockey")) return HO_TEMPLATES;
  if (name.includes("Judo")) return JU_TEMPLATES;
  if (name.includes("Pentathlon")) return MP_TEMPLATES;
  if (name.includes("Rowing")) return RO_TEMPLATES;
  if (name.includes("Sailing")) return SA_TEMPLATES;
  if (name.includes("Shooting")) return SH_TEMPLATES;
  if (name.includes("Table Tennis")) return TT_TEMPLATES;
  if (name.includes("Taekwondo")) return TK_TEMPLATES;
  if (name.includes("Tennis")) return TE_TEMPLATES;
  if (name.includes("Triathlon")) return TR_TEMPLATES;
  if (name.includes("Volleyball")) return VO_TEMPLATES;
  if (name.includes("Weightlifting")) return WL_TEMPLATES;
  if (name.includes("Wrestling")) return WR_TEMPLATES;

  const c = code.toUpperCase() || "XX";
  return [
    { id: `${c}001`, name: `${sport.name} Athlete ID Lower Third`, icon: "👤", subCat: "LOWER THIRDS" },
    { id: `${c}002`, name: `${sport.name} Olympic Champion Card`, icon: "🥇", subCat: "LOWER THIRDS" },
    { id: `${c}003`, name: `${sport.name} Live Scoreboard Bug`, icon: "📊", subCat: "SCORES & MATCH" },
    { id: `${c}004`, name: `${sport.name} Final Results Table`, icon: "🏆", subCat: "RESULTS & STANDINGS" },
    { id: `${c}005`, name: `${sport.name} Podium Medallists & Country Tally`, icon: "🥇", subCat: "RESULTS & STANDINGS" },
    { id: `${c}006`, name: `${sport.name} Venue & Event Corner Bug`, icon: "🏷️", subCat: "RECORDS & BUGS" },
  ];
}
